(() => {
  const money = (cents = 0) => new Intl.NumberFormat('en-PH', {
    style: 'currency', currency: 'PHP', minimumFractionDigits: 0, maximumFractionDigits: 0
  }).format(Number(cents || 0) / 100).replace('PHP', '₱');

  const normalizeOption = (value = '') => String(value)
    .toLowerCase().replace(/carats/g, 'carat').replace(/\s+/g, ' ').trim();

  const optionMatches = (actual, desired) => {
    const a = normalizeOption(actual), d = normalizeOption(desired);
    if (!d || a === d) return true;
    const dSize = d.replace(/^us\s+/, '').replace(/^size\s+/, '');
    const aSize = a.replace(/^us\s+/, '').replace(/^size\s+/, '');
    if (/^\d+(\.\d+)?$/.test(dSize) && aSize === dSize) return true;
    return a.includes(d) || d.includes(a);
  };

  const body = document.body;
  const overlay = document.querySelector('[data-drawer-overlay]');
  const drawers = Array.from(document.querySelectorAll('.elaris-drawer'));

  const closeDrawers = () => {
    drawers.forEach((d) => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    if (overlay) { overlay.hidden = true; overlay.classList.remove('is-visible'); }
    body.classList.remove('drawer-open');
  };

  const openDrawer = (drawer) => {
    if (!drawer) return;
    closeDrawers();
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    if (overlay) { overlay.hidden = false; requestAnimationFrame(() => overlay.classList.add('is-visible')); }
    body.classList.add('drawer-open');
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-close-drawers]') || e.target === overlay) closeDrawers();
    if (e.target.closest('[data-open-cart]')) { openCartDrawer(); }
    if (e.target.closest('[data-open-wishlist]')) { renderWishlist(); openDrawer(document.querySelector('[data-wishlist-drawer]')); }
    if (e.target.closest('[data-open-search]')) {
      const drawer = document.querySelector('[data-search-drawer]'); openDrawer(drawer);
      setTimeout(() => drawer?.querySelector('[data-predictive-search-input]')?.focus(), 120);
    }
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawers(); });

  const refreshCartCount = async () => {
    try {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!r.ok) return null;
      const cart = await r.json();
      document.querySelectorAll('.cart-count').forEach((el) => { el.textContent = cart.item_count; });
      return cart;
    } catch (_) { return null; }
  };

  const renderCart = (cart) => {
    const container = document.querySelector('[data-cart-drawer-body]');
    const foot = document.querySelector('[data-cart-drawer-foot]');
    const total = document.querySelector('[data-cart-drawer-total]');
    if (!container || !cart) return;
    if (!cart.items?.length) {
      container.innerHTML = `<div class="drawer-empty"><span>◇</span><h3>Your bag is waiting.</h3><p>Discover an ELARIS piece worth keeping.</p><a class="btn btn--rose" href="/collections/all">Explore jewelry</a></div>`;
      if (foot) foot.hidden = true;
      return;
    }
    container.innerHTML = cart.items.map((item) => `
      <article class="drawer-cart-item">
        <a class="drawer-cart-image" href="${item.url}">${item.image ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}">` : '<div class="drawer-image-placeholder">ELARIS</div>'}</a>
        <div class="drawer-cart-copy">
          <a href="${item.url}" class="drawer-cart-title">${escapeHtml(item.product_title)}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="drawer-cart-variant">${escapeHtml(item.variant_title)}</div>` : ''}
          <div class="drawer-cart-price">${money(item.final_line_price)}</div>
          <div class="drawer-cart-actions"><span>Qty ${item.quantity}</span><button type="button" data-cart-remove data-line-key="${item.key}">Remove</button></div>
        </div>
      </article>`).join('');
    if (total) total.textContent = money(cart.total_price);
    if (foot) foot.hidden = false;
  };

  const openCartDrawer = async () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) { window.location.href = '/cart'; return; }
    openDrawer(drawer);
    const cart = await refreshCartCount(); renderCart(cart);
  };

  document.addEventListener('click', async (e) => {
    const remove = e.target.closest('[data-cart-remove]');
    if (!remove) return;
    remove.disabled = true;
    try {
      const r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: remove.dataset.lineKey, quantity: 0 }) });
      if (!r.ok) throw new Error('Unable to update bag.');
      const cart = await r.json(); renderCart(cart); document.querySelectorAll('.cart-count').forEach((el) => el.textContent = cart.item_count);
    } catch (_) { remove.disabled = false; }
  });

  const addVariant = async (variantId, quantity = 1) => {
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity || 1) }] }) });
    if (!r.ok) {
      let detail = 'Unable to add this piece to your bag.';
      try { detail = (await r.json()).description || detail; } catch (_) {}
      throw new Error(detail);
    }
    return r.json();
  };

  const setStatus = (container, message, type = '') => {
    if (!container) return;
    container.textContent = message; container.classList.remove('is-success', 'is-error');
    if (type) container.classList.add(`is-${type}`);
  };

  const findVariantForCard = (product, card) => {
    const desired = Array.from(card?.querySelectorAll('[data-cart-option]') || []).map((select) => {
      const option = select.options?.[select.selectedIndex];
      return option?.dataset.cartValue || option?.textContent?.split('—')[0]?.trim() || select.value;
    }).filter(Boolean);
    const available = (product.variants || []).filter((variant) => variant.available !== false);
    if (!available.length) return null;
    if (!desired.length) return available[0];
    return available.find((variant) => desired.every((wanted) => (variant.options || []).some((actual) => optionMatches(actual, wanted)))) || null;
  };

  document.addEventListener('click', async (e) => {
    const button = e.target.closest('[data-elaris-add-to-cart]');
    if (!button) return;
    const card = button.closest('[data-elaris-catalog-card]');
    const status = card?.querySelector('[data-cart-status]');
    const handle = button.dataset.productHandle, original = button.textContent;
    if (!handle) return;
    button.disabled = true; button.textContent = 'Adding…'; setStatus(status, '');
    try {
      const productResponse = await fetch(`/products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
      if (!productResponse.ok) throw new Error('This catalog item is not connected to its Shopify product yet.');
      const product = await productResponse.json();
      const variant = findVariantForCard(product, card);
      if (!variant) throw new Error('The selected option is currently unavailable.');
      await addVariant(variant.id, 1); await refreshCartCount();
      button.textContent = 'Added ✓'; setStatus(status, 'Added to your bag.', 'success');
      await openCartDrawer();
      window.setTimeout(() => { button.textContent = original; button.disabled = false; }, 1200);
    } catch (err) { button.textContent = original; button.disabled = false; setStatus(status, err.message, 'error'); }
  });

  // Native product and quick-add forms become AJAX so the client stays in context.
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    const isProduct = !!form.closest('.product-main');
    const isQuickAdd = form.classList.contains('quick-add-form');
    if (!isProduct && !isQuickAdd) return;
    if (e.submitter?.closest?.('.shopify-payment-button') || e.submitter?.classList?.contains('shopify-payment-button__button')) return;
    e.preventDefault();
    const button = form.querySelector('[data-product-submit], button[type="submit"]');
    const status = form.querySelector('[data-quick-add-status]');
    if (!button) return;
    const original = button.textContent; button.disabled = true; button.textContent = 'Adding…'; setStatus(status, '');
    try {
      const fd = new FormData(form);
      const r = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      if (!r.ok) {
        let msg = 'Unable to add this piece to your bag.'; try { msg = (await r.json()).description || msg; } catch (_) {}
        throw new Error(msg);
      }
      button.textContent = 'Added ✓'; setStatus(status, 'Added to your bag.', 'success'); await refreshCartCount(); await openCartDrawer();
      window.setTimeout(() => { button.textContent = original; button.disabled = false; }, 1000);
    } catch (err) { button.textContent = original; button.disabled = false; setStatus(status, err.message, 'error'); }
  });

  // Product variant selection + luxury gold swatches.
  document.querySelectorAll('.product-main form[action*="/cart/add"]').forEach((form) => {
    const root = form.closest('[data-product-root]');
    const selects = Array.from(form.querySelectorAll('[data-product-option]'));
    const idInput = form.querySelector('[data-variant-id]');
    const variantsScript = form.querySelector('[data-product-variants]');
    const inventoryScript = form.querySelector('[data-product-inventory]');
    const price = root?.querySelector('[data-product-price]');
    const comparePrice = root?.querySelector('[data-product-compare-price]');
    const discountBadge = root?.querySelector('[data-product-discount-badge]');
    const stickyPrice = root?.querySelector('[data-mobile-sticky-price]');
    const submit = form.querySelector('[data-product-submit]');
    const stickySubmit = root?.querySelector('[data-mobile-sticky-submit]');
    const stockBadge = root?.querySelector('[data-stock-badge]');
    const availability = root?.querySelector('[data-product-availability]');
    if (!idInput || !variantsScript) return;
    let variants = [], inventory = {};
    try { variants = JSON.parse(variantsScript.textContent || '[]'); } catch (_) {}
    try { inventory = JSON.parse(inventoryScript?.textContent || '{}'); } catch (_) {}

    const update = () => {
      const values = selects.map((s) => s.value);
      const variant = values.length ? variants.find((v) => values.every((value, i) => v.options?.[i] === value)) : variants[0];
      if (!variant) {
        [submit, stickySubmit].forEach((b) => { if (b) { b.disabled = true; b.textContent = 'Unavailable'; } }); return;
      }
      idInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      const hasCompare = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
      if (comparePrice) {
        comparePrice.textContent = hasCompare ? money(variant.compare_at_price) : '';
        comparePrice.classList.toggle('is-hidden', !hasCompare);
      }
      if (discountBadge) {
        let pct = '';
        if (hasCompare) pct = Math.round((1 - Number(variant.price) / Number(variant.compare_at_price)) * 100) + '% OFF';
        discountBadge.textContent = pct;
        discountBadge.classList.toggle('is-hidden', !hasCompare);
      }
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      const privatePanel = root?.querySelector('[data-private-client-panel]'); if (privatePanel) privatePanel.classList.toggle('is-hidden', Number(variant.price || 0) < Number(privatePanel.dataset.threshold || 30000000));
      [submit, stickySubmit].forEach((b) => { if (b) { b.disabled = variant.available === false; b.textContent = variant.available === false ? 'Sold out' : 'Add to Cart'; } });
      if (availability) availability.textContent = variant.available === false ? 'Currently unavailable' : 'Ready to reserve online';
      if (stockBadge) {
        const qty = Number(inventory[String(variant.id)] ?? 0);
        stockBadge.textContent = variant.available === false ? 'Sold out' : (qty === 1 ? 'Only 1 available' : 'Limited availability');
        stockBadge.classList.toggle('is-soft', qty !== 1);
      }
      root?.querySelectorAll('[data-option-swatch-group]').forEach((group) => {
        const index = Number(group.dataset.optionIndex); const selected = values[index];
        group.querySelectorAll('[data-option-swatch-value]').forEach((btn) => { const on = btn.dataset.optionSwatchValue === selected; btn.classList.toggle('is-selected', on); btn.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      });
    };
    selects.forEach((s) => s.addEventListener('change', update)); update();
  });

  document.addEventListener('click', (e) => {
    const swatch = e.target.closest('[data-option-swatch-value]');
    if (swatch) {
      const group = swatch.closest('[data-option-swatch-group]'); const root = swatch.closest('.product-main');
      const select = root?.querySelector(`[data-product-option][data-option-index="${group?.dataset.optionIndex}"]`);
      if (select) { select.value = swatch.dataset.optionSwatchValue; select.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    const minus = e.target.closest('[data-qty-minus]'), plus = e.target.closest('[data-qty-plus]');
    if (minus || plus) {
      const input = (minus || plus).closest('.qty')?.querySelector('input[type="number"]'); if (!input) return;
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + (plus ? 1 : -1));
    }
  });

  // Existing static catalog price interactions.
  document.querySelectorAll('[data-earring-option]').forEach((select) => {
    const card = select.closest('.earring-product-card'), price = card?.querySelector('[data-earring-price]');
    const update = () => { const o = select.options[select.selectedIndex]; if (price && o?.dataset.price) price.textContent = o.dataset.price; };
    select.addEventListener('change', update); update();
  });
  document.querySelectorAll('.ring-product-card').forEach((card) => {
    const carat = card.querySelector('[data-ring-carat]'), size = card.querySelector('[data-ring-size]'), price = card.querySelector('[data-ring-price]'), display = card.querySelector('[data-ring-size-display]');
    const update = () => { const c = carat?.options[carat.selectedIndex], s = size?.options[size.selectedIndex]; if (price && c?.dataset.price) price.textContent = c.dataset.price; if (display && s) display.textContent = `US Size ${s.value}`; };
    carat?.addEventListener('change', update); size?.addEventListener('change', update); update();
  });
  document.querySelectorAll('[data-loose-diamond-carat]').forEach((select) => {
    const price = select.closest('.loose-diamond-product-card')?.querySelector('[data-loose-diamond-price]');
    const update = () => { const o = select.options[select.selectedIndex]; if (price && o?.dataset.price) price.textContent = o.dataset.price; };
    select.addEventListener('change', update); update();
  });

  // Wishlist stored privately in the visitor's browser.
  const WISHLIST_KEY = 'elaris:wishlist:v2';
  const loadWishlist = () => { try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch (_) { return []; } };
  const saveWishlist = (items) => { localStorage.setItem(WISHLIST_KEY, JSON.stringify(items.slice(0, 50))); updateWishlistUI(); };
  const updateWishlistUI = () => {
    const items = loadWishlist(); const handles = new Set(items.map((x) => x.handle));
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => el.textContent = items.length);
    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const saved = handles.has(btn.dataset.handle); btn.classList.toggle('is-saved', saved); btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      const icon = btn.querySelector('span[aria-hidden="true"]'); if (icon) icon.textContent = saved ? '♥' : '♡';
    });
  };
  const renderWishlist = () => {
    const container = document.querySelector('[data-wishlist-body]'); if (!container) return;
    const items = loadWishlist();
    if (!items.length) { container.innerHTML = `<div class="drawer-empty"><span>♡</span><h3>No saved pieces yet.</h3><p>Tap the heart on any piece to build your personal ELARIS edit.</p></div>`; return; }
    container.innerHTML = items.map((item) => `<article class="wishlist-item"><a href="${item.url}" class="wishlist-image">${item.image ? `<img src="${item.image}" alt="${escapeHtml(item.title)}">` : '<div class="drawer-image-placeholder">ELARIS</div>'}</a><div><a class="wishlist-title" href="${item.url}">${escapeHtml(item.title)}</a><div class="wishlist-price">${escapeHtml(item.price || '')}</div><button type="button" data-wishlist-remove="${item.handle}">Remove</button></div></article>`).join('');
  };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (btn) {
      e.preventDefault(); const items = loadWishlist(); const idx = items.findIndex((x) => x.handle === btn.dataset.handle);
      if (idx >= 0) items.splice(idx, 1); else items.unshift({ handle: btn.dataset.handle, title: btn.dataset.title, url: btn.dataset.url, image: btn.dataset.image, price: btn.dataset.price });
      saveWishlist(items);
    }
    const remove = e.target.closest('[data-wishlist-remove]');
    if (remove) { saveWishlist(loadWishlist().filter((x) => x.handle !== remove.dataset.wishlistRemove)); renderWishlist(); }
  });
  // Add the same wishlist + quick-view experience to ELARIS curated static catalog cards.
  const enhanceStaticCatalogCards = () => {
    document.querySelectorAll('[data-elaris-catalog-card]').forEach((card) => {
      if (card.querySelector('.static-card-actions')) return;
      const direct = card.querySelector('[data-product-handle]')?.dataset.productHandle;
      const productLink = Array.from(card.querySelectorAll('a[href*=\"/products/\"]')).find((a) => a.getAttribute('href'));
      const href = productLink?.getAttribute('href') || '';
      const handle = direct || (href.match(/\/products\/([^?#/]+)/)?.[1]);
      if (!handle) return;
      const title = card.querySelector('h3')?.textContent?.trim() || 'ELARIS Fine Jewelry';
      const image = card.querySelector('img')?.src || '';
      const price = card.querySelector('[data-ring-price],[data-earring-price],[data-loose-diamond-price],.necklace-selected-price,.bracelet-selected-price,.price')?.textContent?.trim() || '';
      const media = card.querySelector('.ring-product-media,.earring-product-media,.loose-diamond-product-media,.necklace-product-media,.bracelet-product-media,.card-media');
      if (!media) return;
      const actions = document.createElement('div'); actions.className = 'static-card-actions';
      const origin = card.querySelector('.mini-badge--origin,.natural-origin-badge')?.textContent?.trim() || '';
      const settingText = card.querySelector('.ring-specs,.earring-specs,.necklace-specs,.bracelet-specs')?.textContent || '';
      const setting = settingText.match(/(?:14K|18K)[^·\n]*/)?.[0]?.trim() || '';
      actions.innerHTML = `${document.querySelector('[data-wishlist-drawer]') ? `<button class=\"card-icon-button\" type=\"button\" data-wishlist-toggle data-handle=\"${escapeHtml(handle)}\" data-title=\"${escapeHtml(title)}\" data-url=\"/products/${encodeURIComponent(handle)}\" data-image=\"${escapeHtml(image)}\" data-price=\"${escapeHtml(price)}\" aria-label=\"Save ${escapeHtml(title)}\"><span aria-hidden=\"true\">♡</span></button>` : ''}${document.querySelector('[data-compare-drawer]') ? `<button class=\"card-icon-button\" type=\"button\" data-compare-toggle data-handle=\"${escapeHtml(handle)}\" data-title=\"${escapeHtml(title)}\" data-url=\"/products/${encodeURIComponent(handle)}\" data-image=\"${escapeHtml(image)}\" data-price=\"${escapeHtml(price)}\" data-origin=\"${escapeHtml(origin)}\" data-setting=\"${escapeHtml(setting)}\" aria-label=\"Compare ${escapeHtml(title)}\"><span aria-hidden=\"true\">◇</span></button>` : ''}<button class=\"card-icon-button\" type=\"button\" data-quick-view data-handle=\"${escapeHtml(handle)}\" aria-label=\"Quick view ${escapeHtml(title)}\"><span aria-hidden=\"true\">＋</span></button>`;
      media.appendChild(actions);
    });
  };
  enhanceStaticCatalogCards();
  updateWishlistUI();

  // Predictive search.
  const searchInput = document.querySelector('[data-predictive-search-input]');
  const searchResults = document.querySelector('[data-predictive-search-results]');
  let searchTimer;
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer); const q = searchInput.value.trim();
    if (q.length < 2) return;
    searchTimer = setTimeout(async () => {
      try {
        searchResults.innerHTML = '<p class="search-prompt">Searching…</p>';
        const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
        const r = await fetch(url, { headers: { Accept: 'application/json' } }); const data = await r.json();
        const products = data?.resources?.results?.products || [];
        searchResults.innerHTML = products.length ? `<div class="predictive-grid">${products.map((p) => `<a class="predictive-item" href="${p.url}">${p.image ? `<img src="${p.image}" alt="${escapeHtml(p.title)}">` : '<div class="predictive-placeholder">ELARIS</div>'}<span><strong>${escapeHtml(p.title)}</strong><small>View piece</small></span></a>`).join('')}</div><a class="search-all-link" href="/search?q=${encodeURIComponent(q)}&type=product">View all results →</a>` : '<p class="search-prompt">No pieces found. Try another shape or jewelry type.</p>';
      } catch (_) { searchResults.innerHTML = '<p class="search-prompt">Search is temporarily unavailable.</p>'; }
    }, 240);
  });

  // Quick view.
  const quickModal = document.querySelector('[data-quick-view-modal]'), quickContent = document.querySelector('[data-quick-view-content]');
  document.addEventListener('click', async (e) => {
    const trigger = e.target.closest('[data-quick-view]');
    if (trigger) {
      e.preventDefault(); if (!quickModal || !quickContent) return;
      quickModal.hidden = false; quickModal.setAttribute('aria-hidden', 'false'); body.classList.add('drawer-open'); quickContent.innerHTML = '<div class="quick-view-loading">Loading piece…</div>';
      try {
        const r = await fetch(`/products/${encodeURIComponent(trigger.dataset.handle)}.js`, { headers: { Accept: 'application/json' } }); const p = await r.json();
        const clickedImage = trigger.closest('[data-product-card],[data-elaris-catalog-card]')?.querySelector('img')?.src || '';
        quickContent.innerHTML = `<div class="quick-view-grid"><div class="quick-view-media">${p.featured_image ? `<img src="${p.featured_image}" alt="${escapeHtml(p.title)}">` : clickedImage ? `<img src="${clickedImage}" alt="${escapeHtml(p.title)}">` : '<div class="placeholder"><span>ELARIS</span></div>'}</div><div class="quick-view-copy"><p class="eyebrow">ELARIS FINE JEWELRY</p><h2>${escapeHtml(p.title)}</h2><div class="quick-view-price">${money(p.price)}</div><p>${p.variants?.length > 1 ? `${p.variants.length} configurations available. Select carat, size, and metal options on the full product page.` : 'A refined ELARIS piece available for secure purchase online.'}</p><a class="btn btn--rose" href="${p.url}">${p.variants?.length > 1 ? 'Choose Options' : 'View Piece'}</a><button class="quick-view-secondary" type="button" data-close-quick-view>Continue browsing</button></div></div>`;
      } catch (_) { quickContent.innerHTML = '<p>Unable to load this piece right now.</p>'; }
    }
    if (e.target.closest('[data-close-quick-view]')) { quickModal.hidden = true; quickModal.setAttribute('aria-hidden', 'true'); body.classList.remove('drawer-open'); }
  });

  // Product image lightbox and ring size guide.
  const lightbox = document.querySelector('[data-product-lightbox]'), lightboxImage = document.querySelector('[data-lightbox-image]');
  const sizeGuide = document.querySelector('[data-size-guide-modal]');
  document.addEventListener('click', (e) => {
    const zoom = e.target.closest('[data-open-lightbox]');
    if (zoom && lightbox && lightboxImage) { lightboxImage.src = zoom.dataset.lightboxSrc; lightboxImage.alt = zoom.querySelector('img')?.alt || 'ELARIS jewelry'; lightbox.hidden = false; lightbox.setAttribute('aria-hidden', 'false'); body.classList.add('drawer-open'); }
    if (e.target.closest('[data-close-lightbox]')) { lightbox.hidden = true; lightbox.setAttribute('aria-hidden', 'true'); body.classList.remove('drawer-open'); }
    if (e.target.closest('[data-open-size-guide], .size-guide-link')) { e.preventDefault(); if (sizeGuide) { sizeGuide.hidden = false; sizeGuide.setAttribute('aria-hidden', 'false'); body.classList.add('drawer-open'); } }
    if (e.target.closest('[data-close-size-guide]')) { sizeGuide.hidden = true; sizeGuide.setAttribute('aria-hidden', 'true'); body.classList.remove('drawer-open'); }
  });

  document.querySelector('[data-share-product]')?.addEventListener('click', async () => {
    const root = document.querySelector('[data-product-root]'); const data = { title: root?.dataset.productTitle || document.title, url: location.href };
    try { if (navigator.share) await navigator.share(data); else { await navigator.clipboard.writeText(location.href); alert('Product link copied.'); } } catch (_) {}
  });

  // Recently viewed.
  const RECENT_KEY = 'elaris:recent:v2';
  const productRoot = document.querySelector('[data-product-root]');
  if (productRoot) {
    let items = []; try { items = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (_) {}
    const current = { handle: productRoot.dataset.productHandle, title: productRoot.dataset.productTitle, url: productRoot.dataset.productUrl, image: productRoot.dataset.productImage, price: productRoot.dataset.productPriceLabel };
    items = [current, ...items.filter((x) => x.handle !== current.handle)].slice(0, 8); localStorage.setItem(RECENT_KEY, JSON.stringify(items));
    const section = document.querySelector('[data-recently-viewed-section]'), grid = document.querySelector('[data-recently-viewed-grid]');
    const others = items.filter((x) => x.handle !== current.handle).slice(0, 4);
    if (section && grid && others.length) {
      grid.innerHTML = others.map((x) => `<article class="card product-card recent-card"><a href="${x.url}"><div class="card-media">${x.image ? `<img src="${x.image}" alt="${escapeHtml(x.title)}" loading="lazy">` : '<div class="placeholder"><span>ELARIS</span></div>'}</div><div class="card-info"><div class="card-kicker">Recently viewed</div><h3 class="card-title">${escapeHtml(x.title)}</h3><div class="price">${escapeHtml(x.price || '')}</div></div></a></article>`).join('');
      section.hidden = false;
    }
  }

  // Native Shopify related recommendations loaded asynchronously.
  document.querySelectorAll('[data-product-recommendations-url]').forEach(async (section) => {
    try {
      const r = await fetch(section.dataset.productRecommendationsUrl); if (!r.ok) return;
      const html = document.createElement('div'); html.innerHTML = await r.text();
      const incoming = html.querySelector('[data-product-recommendations-url]');
      if (incoming?.innerHTML.trim()) section.innerHTML = incoming.innerHTML;
    } catch (_) {}
  });

  // Collection filters.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-toggle-filters]'); if (!btn) return;
    const filters = document.querySelector('[data-collection-filters]'); if (!filters) return;
    filters.hidden = !filters.hidden; btn.classList.toggle('is-active', !filters.hidden);
  });

  // Subtle reveal motion, respecting reduced-motion preferences.
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }), { threshold: 0.08 });
    document.querySelectorAll('.reveal-section, .product-card').forEach((el) => { el.classList.add('reveal-ready'); observer.observe(el); });
  }

  // Mobile gallery progress dots.
  const gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    const dots = Array.from(document.querySelectorAll('.gallery-mobile-dots span'));
    gallery.addEventListener('scroll', () => {
      if (!dots.length || window.innerWidth > 749) return;
      const width = gallery.clientWidth || 1; const index = Math.max(0, Math.min(dots.length - 1, Math.round(gallery.scrollLeft / width)));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    }, { passive: true });
  }

  function escapeHtml(value = '') {
    return String(value).replace(/[&<>'"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[c]));
  }

  // Compare pieces stored privately in the visitor's browser.
  const COMPARE_KEY = 'elaris:compare:v1';
  const loadCompare = () => { try { return JSON.parse(localStorage.getItem(COMPARE_KEY) || '[]'); } catch (_) { return []; } };
  const saveCompare = (items) => { localStorage.setItem(COMPARE_KEY, JSON.stringify(items.slice(0, 3))); updateCompareUI(); renderCompare(); };
  const updateCompareUI = () => {
    const items = loadCompare(); const handles = new Set(items.map((x) => x.handle));
    document.querySelectorAll('[data-compare-count]').forEach((el) => el.textContent = items.length);
    document.querySelectorAll('[data-compare-toggle]').forEach((btn) => {
      const on = handles.has(btn.dataset.handle); btn.classList.toggle('is-compared', on); btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      const text = btn.querySelector('[data-compare-label]'); if (text) text.textContent = on ? 'Comparing' : 'Compare';
    });
  };
  const renderCompare = () => {
    const container = document.querySelector('[data-compare-body]'); if (!container) return;
    const items = loadCompare();
    if (!items.length) { container.innerHTML = `<div class="drawer-empty"><span>◇</span><h3>No pieces selected.</h3><p>Add up to three pieces to compare price, diamond origin, and setting.</p></div>`; return; }
    container.innerHTML = `<div class="compare-grid">${items.map((item) => `<article class="compare-item"><a href="${item.url}" class="compare-image">${item.image ? `<img src="${item.image}" alt="${escapeHtml(item.title)}">` : '<div class="drawer-image-placeholder">ELARIS</div>'}</a><h3><a href="${item.url}">${escapeHtml(item.title)}</a></h3><dl><div><dt>Price</dt><dd>${escapeHtml(item.price || '—')}</dd></div><div><dt>Origin</dt><dd>${escapeHtml(item.origin || 'See product')}</dd></div><div><dt>Setting</dt><dd>${escapeHtml(item.setting || 'See product')}</dd></div></dl><button type="button" data-compare-remove="${escapeHtml(item.handle)}">Remove</button></article>`).join('')}</div>`;
  };
  const openCompareDrawer = () => { const d = document.querySelector('[data-compare-drawer]'); if (!d) return; renderCompare(); openDrawer(d); };
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-open-compare]'); if (open) { e.preventDefault(); openCompareDrawer(); }
    const btn = e.target.closest('[data-compare-toggle]');
    if (btn) {
      e.preventDefault(); let items = loadCompare(); const idx = items.findIndex((x) => x.handle === btn.dataset.handle);
      if (idx >= 0) items.splice(idx,1); else { if (items.length >= 3) items.shift(); items.push({handle:btn.dataset.handle,title:btn.dataset.title,url:btn.dataset.url,image:btn.dataset.image,price:btn.dataset.price,origin:btn.dataset.origin,setting:btn.dataset.setting}); }
      saveCompare(items);
    }
    const remove = e.target.closest('[data-compare-remove]'); if (remove) saveCompare(loadCompare().filter((x) => x.handle !== remove.dataset.compareRemove));
    if (e.target.closest('[data-clear-compare]')) saveCompare([]);
  });
  updateCompareUI(); renderCompare();



  // ELARIS V5.1 — Quick Refine engine for collections and search results.
  const initRefine = (root) => {
    const grid = root.parentElement?.querySelector('[data-refine-grid]') || document.querySelector('[data-refine-grid]');
    if (!grid) return;
    const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
    const count = root.parentElement?.querySelector('[data-refine-visible-count]') || document.querySelector('[data-refine-visible-count]');
    const empty = root.parentElement?.querySelector('[data-refine-empty]') || document.querySelector('[data-refine-empty]');
    const textInput = root.querySelector('[data-refine-text]');
    const state = { origin: 'all', price: 'all', available: false, text: '' };

    const priceMatch = (price, mode) => {
      const p = Number(price || 0) / 100;
      if (mode === 'under100') return p < 100000;
      if (mode === '100to300') return p >= 100000 && p < 300000;
      if (mode === '300plus') return p >= 300000;
      return true;
    };
    const apply = () => {
      let visible = 0;
      cards.forEach((card) => {
        const origin = (card.dataset.refineOrigin || '').toLowerCase();
        const haystack = `${card.dataset.refineTitle || ''} ${card.dataset.refineType || ''} ${card.dataset.refineTags || ''} ${card.dataset.refineSetting || ''}`.toLowerCase();
        const originOk = state.origin === 'all' || (state.origin === 'natural' ? origin.includes('natural') : origin.includes('lab-grown'));
        const priceOk = priceMatch(card.dataset.refinePrice, state.price);
        const availabilityOk = !state.available || card.dataset.refineAvailable === 'true';
        const textOk = !state.text || state.text.split(/\s+/).filter(Boolean).every((word) => haystack.includes(word));
        const show = originOk && priceOk && availabilityOk && textOk;
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (count) count.textContent = visible;
      if (empty) empty.hidden = visible !== 0;
      const active = state.origin !== 'all' || state.price !== 'all' || state.available || state.text;
      root.querySelectorAll('[data-refine-reset]').forEach((btn) => btn.hidden = !active);
      grid.classList.toggle('is-filtering', active);
    };
    const activateExclusive = (selector, clicked) => {
      root.querySelectorAll(selector).forEach((btn) => btn.classList.toggle('is-active', btn === clicked));
    };
    root.addEventListener('click', (e) => {
      const origin = e.target.closest('[data-refine-origin]');
      if (origin) { state.origin = origin.dataset.refineOrigin; activateExclusive('[data-refine-origin]', origin); apply(); return; }
      const price = e.target.closest('[data-refine-price]');
      if (price) { state.price = price.dataset.refinePrice; activateExclusive('[data-refine-price]', price); apply(); return; }
      const available = e.target.closest('[data-refine-available]');
      if (available) { state.available = !state.available; available.classList.toggle('is-active', state.available); apply(); return; }
      if (e.target.closest('[data-refine-reset]')) {
        state.origin = 'all'; state.price = 'all'; state.available = false; state.text = '';
        if (textInput) textInput.value = '';
        root.querySelectorAll('[data-refine-origin]').forEach((b) => b.classList.toggle('is-active', b.dataset.refineOrigin === 'all'));
        root.querySelectorAll('[data-refine-price]').forEach((b) => b.classList.toggle('is-active', b.dataset.refinePrice === 'all'));
        root.querySelectorAll('[data-refine-available]').forEach((b) => b.classList.remove('is-active'));
        apply();
      }
    });
    textInput?.addEventListener('input', () => { state.text = textInput.value.trim().toLowerCase(); apply(); });

    // Respect smart-search budget parameter when arriving from a natural-language search.
    const params = new URLSearchParams(location.search);
    const incomingPrice = params.get('elaris_price');
    if (incomingPrice && ['under100','100to300','300plus'].includes(incomingPrice)) {
      state.price = incomingPrice;
      root.querySelectorAll('[data-refine-price]').forEach((b) => b.classList.toggle('is-active', b.dataset.refinePrice === incomingPrice));
    }
    apply();
  };
  document.querySelectorAll('[data-refine-root]').forEach(initRefine);

  // Natural-language budget shortcuts: "under 100k", "300k+", "over 300k".
  document.querySelectorAll('[data-smart-search-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      const input = form.querySelector('[data-smart-search-input]');
      if (!input) return;
      let q = input.value.trim();
      let priceMode = '';
      const normalized = q.toLowerCase().replace(/₱/g, '').replace(/,/g, '');
      if (/\b(under|below|less than)\s*100k?\b/.test(normalized) || /\bunder\s*100000\b/.test(normalized)) priceMode = 'under100';
      else if (/\b(300k\+|over\s*300k|above\s*300k|300000\+)\b/.test(normalized)) priceMode = '300plus';
      else if (/\b(100k\s*(to|-)\s*300k|100000\s*(to|-)\s*300000)\b/.test(normalized)) priceMode = '100to300';
      if (!priceMode) return;
      e.preventDefault();
      q = q
        .replace(/\b(under|below|less than)\s*₱?\s*100(?:,?000|k)?\b/ig, '')
        .replace(/\b(?:₱?\s*)?300(?:,?000|k)\+\b/ig, '')
        .replace(/\b(over|above)\s*₱?\s*300(?:,?000|k)?\b/ig, '')
        .replace(/\b₱?\s*100(?:,?000|k)?\s*(?:to|-)\s*₱?\s*300(?:,?000|k)?\b/ig, '')
        .replace(/\s+/g, ' ').trim();
      if (!q) q = 'diamond';
      const url = `/search?q=${encodeURIComponent(q)}&type=product&elaris_price=${encodeURIComponent(priceMode)}`;
      location.href = url;
    });
  });

  // Editorial product gallery: thumbnail navigation + live counter.
  const editorialGallery = document.querySelector('[data-product-gallery]');
  if (editorialGallery) {
    const items = Array.from(editorialGallery.querySelectorAll('.product-media-item'));
    const thumbs = Array.from(document.querySelectorAll('[data-gallery-thumb]'));
    const current = document.querySelector('[data-gallery-current]');
    const setGalleryIndex = (index) => {
      index = Math.max(0, Math.min(items.length - 1, index));
      if (current) current.textContent = String(index + 1);
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
      const index = Number(thumb.dataset.galleryThumb || 0);
      const item = items[index];
      if (!item) return;
      if (window.innerWidth < 990) editorialGallery.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      else item.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setGalleryIndex(index);
    }));
    if (items.length > 1) {
      const observer = new IntersectionObserver((entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting).sort((a,b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!visible) return;
        const index = items.indexOf(visible.target); if (index >= 0) setGalleryIndex(index);
      }, { root: window.innerWidth < 990 ? editorialGallery : null, threshold: [0.45, 0.7] });
      items.forEach((item) => observer.observe(item));
    }
    setGalleryIndex(0);
  }

})();
